import React from "react"
import { has } from "lodash"

import ProjectEmailEntry from "./ProjectEmailEntry"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPlusCircle, faCheckCircle, faSave, faSpinner } from "@fortawesome/free-solid-svg-icons"

class ProjectInvite extends React.Component{
    constructor(){
        super()
        this.state = {
            friendEmails: [],
            ready: true,
            savedMessage: "",
            isLoading: true,
            oldFriendEmails: [],
            error: ""
        }
    }
    handleSubmit = (e) =>{
        e.preventDefault();
        const projectId = this.props.id
        const added = this.state.friendEmails.filter(v => this.state.oldFriendEmails.indexOf(v) === -1);
        const deleted = this.state.oldFriendEmails.filter(v => this.state.friendEmails.indexOf(v) === -1);
        fetch(`/api/data/project/${projectId}/testers`,{
            method: "post",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                added,
                deleted,
            })
        })
        .then(res => res.json())
        .then(data => {if (has(data,"error")){ throw data }})
        .then(function(){ return fetch(`/api/data/project/${projectId}/testers`)})
        .then(res => res.json())
        .then(data => {
            if (has(data,"error")){ throw data }
            const emails = data.result.map(email => email.email);
            this.setState({
                friendEmails: [...emails],
                oldFriendEmails: [...emails],
                savedMessage: <><FontAwesomeIcon icon={faCheckCircle} /> Saved!</>
            })
        })
        .catch(data => this.setState({error: `Server: ${data.error}`}))
    }
    componentDidMount(){
        fetch(`/api/data/project/${this.props.id}/testers`)
        .then(res => res.json())
        .then(data => {
            if (has(data,"error")){ throw data }
            const emails = data.result.map(email => email.email);
            this.setState({
                friendEmails: [...emails],
                oldFriendEmails: [...emails],
                isLoading: false
            })
        })
        .catch(data => this.setState({error: `Server: ${data.error}`, isLoading: false}))
    }
    addInput = (e) =>{
        e.preventDefault()
        this.setState(prevState =>{
            return {
                friendEmails: prevState.friendEmails.concat([""]),
                ready: false,
                savedMessage: "", 
                error: ""
            }
        })
    }
    saveEmail = (value, index) =>{
        const friendEmails = this.state.friendEmails;
        friendEmails[index] = value;
        this.setState({
            friendEmails: [...friendEmails],
            ready: true,
            savedMessage: ""
        })
    }
    deleteEmail = (index) => {
        this.state.friendEmails.splice(index, 1);
        let tempReady = false;
        if (!this.state.friendEmails.includes("")) tempReady = true;
        this.setState({
            friendEmails: [...this.state.friendEmails],
            ready: tempReady,
            savedMessage: ""
        });
    }
    render(){
        return(
            <div className="invite">
                <form className="inviteForm">
                    {this.state.isLoading 
                    ? 
                    <div className="loading"><FontAwesomeIcon icon={faSpinner} spin /></div>
                    :
                    this.state.friendEmails 
                        ? 
                        <div className="invitedList">
                            {this.state.friendEmails.map((email, index) => 
                                <ProjectEmailEntry email={email} key={`${index}-${email}`} index={index}
                                            saveEmail={this.saveEmail} deleteEmail={this.deleteEmail}/>)
                            }
                            <button className="addInput inviteEntryBtn" onClick={this.addInput}>
                                <FontAwesomeIcon icon={faPlusCircle} /> Add tester
                            </button>
                        </div>
                        :                         
                        <div className="invitedList">
                            <button className="addInput inviteEntryBtn" onClick={this.addInput}>
                                <FontAwesomeIcon icon={faPlusCircle} /> Add tester
                            </button>
                        </div>}
                    <div className="saveContainer">
                        <div className="save">
                            <button disabled={this.state.ready === false} type="submit" className="saveBtn" onClick={this.handleSubmit}>
                                <FontAwesomeIcon icon={faSave} />&nbsp;
                                Save!
                            </button>
                            <div className="savedMessage">
                                {this.state.savedMessage}
                            </div>
                        </div>
                    </div>
                    <div className="error">{this.state.error}</div>
                </form>
            </div>
        )
    }
}

export default ProjectInvite